import React, { useState } from 'react';
import { useFormik } from 'formik';
import validator from 'validator';
import { useNavigate } from 'react-router-dom';
import t from '@/utils/translate';
import { PASSWORD_RESET_WAIT_TIMEOUT } from '@/state/authentication.slice';
import { authentication as actions } from '@/actions';
import { Button, Container } from '@/components';
import { TextField, Typography } from '@mui/material';

export default ({ loginUrl }: { loginUrl: string }) => {
  const nav = useNavigate();
  const [waitConfirmation, setWaitConfirmation] = useState<boolean>(false);
  const formik = useFormik({
    initialValues: { email: '' },
    validateOnChange: false,
    validateOnBlur: false,
    validate: ({ email }) => {
      const errors: Record<string, string> = {};

      if (!email) {
        errors.email = t('recovery.hint.email');
      } else if (!validator.isEmail(email, { allow_utf8_local_part: false })) {
        errors.email = t('recovery.validation.email');
      }

      return errors;
    },
    onSubmit: async ({ email }) => {
      try {
        formik.setSubmitting(true);
        await actions.startExternalPasswordReset(email);
        setWaitConfirmation(true);
      } finally {
        formik.setSubmitting(false);
      }
    }
  });

  if (waitConfirmation) {
    return <Typography>{t('recovery.message.emailSent', { count: Math.round(PASSWORD_RESET_WAIT_TIMEOUT / 3600) }, true)}</Typography>;
  }

  return (
    <>
      <h3>{t('recovery.title.main')}</h3>
      <Typography>
        {t('recovery.hint.accountEmail', true)}
      </Typography>
      <form onSubmit={formik.handleSubmit}>
        <Container margin-v="small">
          <TextField
            {...formik.getFieldProps('email')}
            disabled={formik.isSubmitting}
            label={t('recovery.label.email')}
            error={formik.touched.email && !!formik.errors.email}
            helperText={formik.touched.email && formik.errors.email}
            fullWidth
            margin="dense"
            variant="outlined"
            autoFocus
            size="small"
          />
        </Container>
        <Button
          type="submit"
          variant="contained"
          fullWidth
          color="primary"
          size="large"
          loading={formik.isSubmitting}
        >
          {t('recovery.action.send')}
        </Button>
        <Button
            type="reset"
            color="inherit"
            fullWidth
            size="large"
            variant="text"
            onClick={() => {
              formik.resetForm();
              nav(loginUrl);
            }}
          >
            {t('recovery.action.back')}
          </Button>
      </form>
    </>
  );
};
